import cx from "classnames";

import { noop } from "common/utils/noop";

import TextButton from "../../../common/components/buttons/TextButton";
import { urls } from "../../../routes";

import styles from "../../styles/SmsLegalDisclaimer.module.less";

export type SmsLegalDisclaimerProps = {
  onLinkClick?: () => void;
  textAlign?: "start" | "center";
};

const SmsLegalDisclaimer = ({
  onLinkClick = noop,
  textAlign = "start",
}: SmsLegalDisclaimerProps) => {
  return (
    <p className={cx(styles.smsLegalDisclaimer, styles[`align-${textAlign}`])}>
      By providing your phone number, you agree that we may contact you at the provided phone number
      with service-related or transactional text messages, such as for verification purposes,
      security alerts, and support communications. Standard message and data rates may apply. See
      our{" "}
      <TextButton
        className={styles.link}
        hasUnderline={true}
        dest={urls.support.privacyPolicy()}
        onClick={onLinkClick}
      >
        Privacy Policy
      </TextButton>{" "}
      for more information.
    </p>
  );
};

export default SmsLegalDisclaimer;
